var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"blog-frame","frameBorder":"0","src":"https://info.enter.hetnieuweinstituut.nl/blog"}})}
var staticRenderFns = []

export { render, staticRenderFns }